import React from "react";
import styles from "./styles.module.scss";
import loginBg from "../../../../../assets/svg/loginbg.svg";

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={styles.mainContainer}
      style={{
        backgroundImage: `url(${loginBg})`,
      }}
      data-testid="main-auth-layout"
    >
      <div className={styles.innerContainer}>
        <div className={styles.formContainer}>
          <div className={styles.heading}>
            <span className={styles.device}>
              DEVICE
              <span className={styles.manager}> MANAGER</span>
            </span>
            <span className={styles.subtitle}>Welcome to Device Manager!</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
